// extracted by mini-css-extract-plugin
export var alertIcon = "_rs-0";